export default "__VITE_ASSET__7a921378__"